<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
        style="display: flex; justify-content: center"
      >
        <v-row justify="center">
          <v-col cols="12" sm="8" md="4">
            <!-- <template v-if="mobsUser">
              <app-logo :src="'img/mobs_violeta.svg'" :alt="'Academia'" />
            </template>

            <template v-else>
              <app-logo />
            </template> -->
            <!-- Logo AESA empieza -->
            <img src="../assets/img/aesa.webp" alt="Aseguradora del Este S.A.">
            <!-- Logo AESA termina -->
            
            <!-- comienza Logo SeguridadSeguros -->
            <!-- <img src="../assets/img/seguridadseguros.webp" alt="Seguridad Seguros"> -->
            <!-- termina Logo SeguridadSeguros -->
            <app-spinner
              v-if="
                loading ||
                (accessWithAutologin &&
                  (autologinStatus === 'pending' ||
                    autologinStatus === 'success'))
              "
            />

            <template>
              <div class="notification-error" v-show="error_message">
                <p>
                  Su usuario y/o contraseña no concuerdan. Intente nuevamente
                </p>
              </div>
              <div class="notification-success" v-show="email_sent === true">
                <p>
                  Se ha enviado un correo electrónico a su casilla de correo con
                  los pasos a seguir.
                </p>
              </div>
              <div class="notification-error" v-show="email_sent === false">
                <p>
                  Ha ocurrido un error. Por favor verifique la dirección de
                  correo ingresada.
                </p>
              </div>
            </template>

            <v-card flat tile>
              <v-card-text>
                <v-form v-if="!loading || !accessWithAutologin">
                  <v-text-field
                    @disabled="loading"
                    @change="email_sent = null"
                    @blur="$v.formLogin.username.$touch()"
                    :error="$v.formLogin.username.$error"
                    :error-messages="usernameErrors"
                    v-model="formLogin.username"
                    label="Usuario"
                    name="login"
                    prepend-inner-icon="person"
                    type="text"
                    autofocus
                    outlined
                  />
                  <v-text-field
                    @blur="$v.formLogin.password.$touch()"
                    :error="$v.formLogin.password.$error"
                    :error-messages="passwordErrors"
                    v-model="formLogin.password"
                    id="password"
                    label="Contraseña"
                    name="password"
                    prepend-inner-icon="lock"
                    type="password"
                    outlined
                  />
                </v-form>
              </v-card-text>

              <v-card-actions class="actions-container">
                <v-btn
                  v-show="!loading"
                  :disabled="$v.formLogin.$invalid"
                  color="info"
                  @click.prevent="login"
                  width="80%"
                  height="45px"
                  >Iniciar sesión</v-btn
                >
                <br />
                <v-btn
                  v-show="!loading"
                  color="rapired"
                  dark
                  @click.prevent="googleLogin"
                  width="80%"
                  height="45px"
                  >Iniciar sesión con Google</v-btn
                >
                <br />
                <v-btn
                  text
                  v-show="!loading"
                  color="primary"
                  :disabled="!formLogin.username || !!email_sent"
                  @click="recoverPassword"
                  >¿Olvidaste tu contraseña?</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import firebase from "firebase/app";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import AppLogo from "../components/Mobs/AppLogo.vue";
import AppSpinner from "../components/Mobs/AppSpinner.vue";
export default {
  name: "login",
  components: { AppLogo, AppSpinner },
  data() {
    return {
      formLogin: {
        username: null,
        password: null,
      },
      error_message: false,
      email_sent: null,
      loading: false,
    };
  },
  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.formLogin.username.$error) return errors;
      !this.$v.formLogin.username.required &&
        errors.push("Ingrese nombre de usuario");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.formLogin.password.$error) return errors;
      !this.$v.formLogin.password.required &&
        errors.push("Ingrese la contraseña");
      return errors;
    },
    autologinStatus() {
      return this.$store.state.auth.autologinStatus;
    },
    accessWithAutologin() {
      return this.$store.getters.signWithLink;
    },
  },
  validations: {
    formLogin: {
      username: { required },
      password: { required },
    },
  },
  methods: {
    ...mapActions({
      signInWithEmailAndPassword: "login",
      signInWithPopUp: "loginWithGoogle",
    }),

    async login() {
      try {
        this.loading = true;
        this.error_message = false;
        await this.signInWithEmailAndPassword({
          email: this.formLogin.username,
          password: this.formLogin.password,
        });
      } catch (error) {
        console.error({ error });
        this.error_message = true;
        throw new Error('Tracked login Error: ' + error);
      } finally {
        this.loading = false;
      }
    },

    async googleLogin() {
      try {
        this.loading = true;
        this.error_message = false;
        const provider = new firebase.auth.GoogleAuthProvider();

        provider.setCustomParameters({
          prompt: "select_account",
        });

        await this.signInWithPopUp({ provider });
      } catch (error) {
        console.log(error);
        this.error_message = true;
        throw new Error('Tracked login Error: ' + error);
      } finally {
        this.loading = false;
      }
    },

    getTechnicianByUID(uid) {
      let baseURL = JSON.parse(localStorage.getItem("baseURL"));
      this.axios
        .get(`technician_by_uid/${uid}/`)
        .then((response) => {
          const technician = response.data;
          localStorage.setItem("technician", JSON.stringify(technician));
        })
        .catch(() => {
          this.error_message = true;
          alert("ERROR");
          console.log("error en getTechnicianByUID: " + uid);
          throw new Error('Tracked login Error: ' + error);
        });
    },

    recoverPassword() {
      const _this = this;
      const auth = firebase.auth();
      auth
        .sendPasswordResetEmail(this.formLogin.username)
        .then(function () {
          _this.email_sent = true;
        })
        .catch(function (error) {
          _this.email_sent = false;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.actions-container {
  display: flex;
  flex-direction: column !important;
  justify-content: center;
  align-items: center;
}

.notification-error,
.notification-success {
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 1rem;
  padding-top: 1rem;
  font-size: 1em;
  color: #ffffff;
  border-radius: 25px;
}
.notification-error {
  background-color: #d1602b;
}
.notification-success {
  background-color: #25c025d2;
}
</style>
